import { Controller } from "stimulus"
import posthog from 'posthog-js'

const COOKIE_NAME = 'chatMessageCount'
const SURVEY_THRESHOLD = 3
const EXPIRATION_MONTHS = 6

export default class extends Controller {

  connect() {
    this.counter = this.getMessageCounter()
  }

  addCounter() {
    this.counter++
    this.updateMessageCounter()

    if (this.shouldShowSurvey()) this.triggerPostHogSurvey();
  }

  shouldShowSurvey() {
    return (this.counter === SURVEY_THRESHOLD || (this.counter > SURVEY_THRESHOLD && (this.counter - SURVEY_THRESHOLD) % 6 === 0))
  }

  getMessageCounter() {
    const cookieValue = document.cookie
      .split('; ')
      .find(cookie => cookie.startsWith(`${COOKIE_NAME}=`))
      ?.split('=')[1]

    const parsed = parseInt(cookieValue, 10)
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0
  }

  updateMessageCounter() {
    const expiryDate = new Date()
    expiryDate.setMonth(expiryDate.getMonth() + EXPIRATION_MONTHS)

    const cookieString = [
      `${COOKIE_NAME}=${this.counter}`,
      `expires=${expiryDate.toUTCString()}`,
      'path=/',
      'SameSite=Strict'
    ].join('; ')

    document.cookie = cookieString
  }

  triggerPostHogSurvey(){
    posthog.capture('survey_triggered_three_messages_sent', { event_properties: { type: 'survey_triggers' } })
  }
}